import { isProductionEnv } from './envs';

const isInternalAccess = (isAdmin) => {
  return !isProductionEnv || [true, undefined, null].includes(isAdmin);
};

const isUserAdmin = (isAdmin) => {
  return [true, undefined, null].includes(isAdmin);
};

export { isInternalAccess, isUserAdmin };
